import { ApiClient } from '@msdk/common'
import { AttachmentValue } from '@msdk/definitions'

const extractFileName = (url: string): string => {
  const urlParts = url.split('/')
  return urlParts[urlParts.length - 1]
}

export const downloadAttachment = async (attachmentValue: AttachmentValue, api: ApiClient) => {
  const b = await api.entity.getAttachmentByUrl(attachmentValue.url)
  const url = window.URL.createObjectURL(b)
  const filename = attachmentValue.originalName ?? extractFileName(attachmentValue.url)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  window.URL.revokeObjectURL(url)
  document.body.removeChild(anchor)
}
